// Liens de telechargement de l'app Clo'Cook, partages par la banniere,
// la page /application, le footer et la FAQ.

export const APP_STORE_ID = '6788099308';
export const APP_STORE_URL = 'https://apps.apple.com/fr/app/clocook/id6788099308';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=fr.clocook.app';
